<template>
  <b-row
    v-if="trackingDetails && trackingDetails.length && !isDuplicated"
    class="invoice-preview"
  >
    <b-col
      md="12"
      sm="12"
      xs="12"
    >
      <b-card no-body>
        <b-card-header>
          <div class="d-flex align-items-center">
            <feather-icon
              size="24"
              class="mr-1"
              icon="TruckIcon"
            />
            <b-card-title class="ml-25 mr-25">
              Suivi de livraison Shippingbo
              <b-badge
                v-if="orderStatus"
                variant="light-success"
                class="ml-50"
              >
                Statut : {{ orderStatus.toUpperCase() }}
              </b-badge>
            </b-card-title>
          </div>
        </b-card-header>

        <b-table-lite
          responsive
          :items="trackingDetails"
          :fields="fields"
          class="mt-2"
          :busy="isLoading"
        >
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle mr-50" />
              <strong>Chargement du suivi...</strong>
            </div>
          </template>

          <template #cell(tracking_url)="data">
            <a
              :href="data.item.tracking_url"
              target="_blank"
              class="font-weight-bold text-primary text-underline"
            >
              Suivre mon colis 🚀
            </a>
          </template>

          <template #cell(carrier_name)="data">
            <span class="font-weight-bold text-capitalize">
              {{ data.item.carrier_name || 'N/A' }}
            </span>
          </template>

          <template #cell(package_info)="data">
            <div class="font-weight-bold text-dark">
              Colis n°{{ data.index + 1 }}
            </div>
            <small class="text-muted d-block">Ref: {{ data.item.shipping_ref }}</small>
            <b-badge
              variant="light-secondary"
              class="mt-25 font-small-1"
            >
              {{ formatWeight(data.item.total_weight_g) }}
            </b-badge>
          </template>

          <template #cell(products)="data">
            <div
              v-for="(prod, index) in data.item.products"
              :key="index"
              class="d-flex align-items-center my-25"
            >
              <b-badge
                variant="light-primary"
                class="mr-50 font-weight-bolder"
              >
                x{{ formatQuantity(prod.quantity_shipped) }}
              </b-badge>

              <div>
                <small class="text-muted font-weight-bold">[{{ prod.sku }}]</small>
                <span class="ml-25 font-small-3 d-block d-md-inline-block text-truncate style-title">
                  {{ prod.title }}
                </span>
                <b-badge
                  v-if="isFraction(prod.quantity_shipped)"
                  variant="light-warning"
                  class="ml-25 font-small-1"
                >
                  Élément de kit
                </b-badge>
              </div>
            </div>
          </template>
        </b-table-lite>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardTitle,
  BBadge,
  BTableLite,
  BSpinner,
} from 'bootstrap-vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'

export default {
  name: 'ShippingboTracking',

  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BBadge,
    BTableLite,
    BSpinner,
    FeatherIcon,
  },

  props: {
    isDuplicated: {
      type: Boolean,
      default: false,
    },
    trackingDetails: {
      type: Array,
      default: () => [],
    },
    orderStatus: {
      type: String,
      default: '',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      fields: [
        { key: 'tracking_url', label: 'TRACKING LINK' },
        { key: 'carrier_name', label: 'CARRIER' },
        { key: 'package_info', label: 'PACKAGE / WEIGHT' },
        { key: 'products', label: 'ITEMS IN PACKAGE' },
      ],
    }
  },

  methods: {
    formatQuantity(qty) {
      if (!qty) return 0
      return qty % 1 !== 0 ? Math.ceil(qty) : qty
    },
    isFraction(qty) {
      return qty ? qty % 1 !== 0 : false
    },
    formatWeight(grams) {
      if (!grams) return '0 kg'
      return `${(grams / 1000).toFixed(0)} kg`
    },
  },
}
</script>

<style scoped>
.style-title {
  max-width: 450px;
  display: inline-block;
  vertical-align: middle;
}
.text-underline {
  text-decoration: underline;
}
.badge-light-secondary {
  background-color: #f3f2f5;
  color: #b9b9c3;
}
.badge-light-warning {
  background-color: #fff3e0;
  color: #ff9800;
}
</style>
